// UI-chrome (non-seeded) static label translations, keyed by the Italian string.
// Italian ('it') falls back to the key itself, so only en/de/fr are listed.
export const UI = {
  en: {
    'Il mio soggiorno': 'My stay',
    'Home': 'Home',
    'Eventi': 'Events',
    'Vicino a te': 'Nearby',
    'Arte e Musei': 'Art & Museums',
    'Servizi': 'Services',
    'Esperienze': 'Experiences',
    'Info BnB': 'B&B Info',
    'Tutti i diritti riservati.': 'All rights reserved.',
    'Privacy': 'Privacy',
    'Termini': 'Terms',
    'Contatti': 'Contact',
    'Servizi e convenzioni per te': 'Services and deals for you',
    'Esperienze consigliate per te': 'Experiences recommended for you',
    'Ordina per': 'Sort by',
    'Consigliati': 'Recommended',
    'Informazioni utili': 'Useful information',
    'Dove siamo': 'Where we are',
    'Posizione della struttura': 'Property location',
    'Funzionalità': 'Features',
    'Prezzi': 'Pricing',
    'Perché Domira': 'Why Domira',
  },
  de: {
    'Il mio soggiorno': 'Mein Aufenthalt',
    'Home': 'Home',
    'Eventi': 'Veranstaltungen',
    'Vicino a te': 'In der Nähe',
    'Arte e Musei': 'Kunst & Museen',
    'Servizi': 'Dienste',
    'Esperienze': 'Erlebnisse',
    'Info BnB': 'B&B-Infos',
    'Tutti i diritti riservati.': 'Alle Rechte vorbehalten.',
    'Privacy': 'Datenschutz',
    'Termini': 'AGB',
    'Contatti': 'Kontakt',
    'Servizi e convenzioni per te': 'Dienste und Angebote für Sie',
    'Esperienze consigliate per te': 'Für Sie empfohlene Erlebnisse',
    'Ordina per': 'Sortieren nach',
    'Consigliati': 'Empfohlen',
    'Informazioni utili': 'Nützliche Informationen',
    'Dove siamo': 'Wo wir sind',
    'Posizione della struttura': 'Standort der Unterkunft',
    'Funzionalità': 'Funktionen',
    'Prezzi': 'Preise',
    'Perché Domira': 'Warum Domira',
  },
  fr: {
    'Il mio soggiorno': 'Mon séjour',
    'Home': 'Accueil',
    'Eventi': 'Événements',
    'Vicino a te': 'À proximité',
    'Arte e Musei': 'Art & Musées',
    'Servizi': 'Services',
    'Esperienze': 'Expériences',
    'Info BnB': 'Infos B&B',
    'Tutti i diritti riservati.': 'Tous droits réservés.',
    'Privacy': 'Confidentialité',
    'Termini': 'Conditions',
    'Contatti': 'Contact',
    'Servizi e convenzioni per te': 'Services et conventions pour vous',
    'Esperienze consigliate per te': 'Expériences recommandées pour vous',
    'Ordina per': 'Trier par',
    'Consigliati': 'Recommandés',
    'Informazioni utili': 'Informations utiles',
    'Dove siamo': 'Où nous sommes',
    'Posizione della struttura': "Emplacement de l'établissement",
    'Funzionalità': 'Fonctionnalités',
    'Prezzi': 'Tarifs',
    'Perché Domira': 'Pourquoi Domira',
  },
};

export function translateUI(lang, text) {
  return (UI[lang] && UI[lang][text]) || text;
}
